import { render, staticRenderFns } from "./RoleCard.vue?vue&type=template&id=44976124&scoped=true"
import script from "./role_card.js?vue&type=script&lang=js&external"
export * from "./role_card.js?vue&type=script&lang=js&external"
import style0 from "./role_card.scss?vue&type=style&index=0&id=44976124&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44976124",
  null
  
)

export default component.exports